import { useState } from "react";
import Draggable from "react-draggable";
import NumberFormat from "react-number-format";

export const BulkDefaultsModal = ({ onCancel, onSave, initialValues = {}, dynamicFields = [], isSubmitting = false, settingsFieldDisabled }) => {
    const [values, setValues] = useState({
        dynamic_fields: dynamicFields.reduce((acc, f) => {
            acc[f.key] = initialValues.dynamic_fields?.[f.key] ?? "";
            return acc;
        }, {})
    });
    const handleDynChange = (key, val) => setValues(v => ({ ...v, dynamic_fields: { ...v.dynamic_fields, [key]: val } }));

    const submitDefaults = () => {
        onSave(values);
    };

    return (
        <div className="modal modal-region modal-view inbox-modal" id="bulkDefaultsModal" tabIndex="-1" style={{ display: "block" }}>
            <Draggable handle=".draggable" cancel=".non-draggable">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title">
                                <div className="txt-hed">Default {settingsFieldDisabled ? "Actual" : "Settings"}</div>
                            </h5>
                            <button type="button" className="close non-draggable" onClick={onCancel}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="Close" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body region-otr sm-chart-upload">
                            <div className="col-md-12 main-sec soft-cost-default overflow-auto">
                                <div className="form-row">
                                    {dynamicFields.map(field => (
                                        <div className="form-group col-12 mb-4" key={field.key}>
                                            <label>
                                                {field.name} ({field.field_type === "dollar" ? "$" : "$ /SF"})
                                            </label>
                                            <NumberFormat
                                                className="form-control"
                                                displayType="input"
                                                value={values.dynamic_fields[field.key]}
                                                onValueChange={vals => handleDynChange(field.key, vals.floatValue)}
                                                prefix={"$"}
                                                suffix={field.field_type === "dollar" ? "" : " /SF"}
                                                decimalScale={3}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="btn-sec">
                                <div className="text-right btnOtr edit-cmn-btn">
                                    <button type="button" className="btn btn-create save" disabled={isSubmitting} onClick={submitDefaults}>
                                        Save{isSubmitting && <span className="spinner-border spinner-border-sm pl-2" role="status"></span>}
                                    </button>
                                    <button type="button" className="btn btn-secondary btnClr mr-1" disabled={isSubmitting} onClick={onCancel}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};
